import { Link } from 'react-router-dom';
import { navItemsFor } from 'config/nav';
import { useNavContext } from './nav/useNavContext';

const footerLinkClass =
    'text-muted-foreground hover:text-foreground text-sm underline-offset-4 hover:underline';

// Secondary links only -- anything a user actually needs to get to lives in
// the top bar or account menu (see config/nav.ts).
export default function Footer() {
    const ctx = useNavContext();
    return (
        <footer className="flex flex-row flex-wrap items-center justify-center gap-x-4 gap-y-1">
            {navItemsFor('footer', ctx).map((item) => (
                <Link key={item.path} to={item.path} className={footerLinkClass}>
                    {item.title}
                </Link>
            ))}
        </footer>
    );
}
